var testimonialJs = (function() {
  function init() {
    uiBindings();
  }

  var uiBindings = function() {
    /**
     *   Video Modal Box
     */
    var modalOverlay = document.querySelectorAll(".js-video-overlay-trigger");
    if (modalOverlay) {
      for (i = 0; i < modalOverlay.length; i++) {
        var modalVideoId = modalOverlay[i].getAttribute("data-video-id"),
          ua = navigator.userAgent.toLowerCase(),
          isSafari = false,
          sandboxFlag = '';

        // Detect browser for allow presentation sandbox flag
        try {
          isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
        }
        catch(err) {}
        isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
        sandboxFlag = isSafari ? '' : 'allow-presentation';

        modalOverlay[i].addEventListener("click", function(e) {
          e.preventDefault();
          if (modalVideoId) {
            var modalVideo = new tingle.modal({
              focusAfterClosed: this,
              closeIconInverse: true,
              onClose: function() {
                modalVideo.destroy();
              }
            });
            modalVideo.setContent(
              '<iframe width="100%" height="400" src="https://www.youtube.com/embed/' +
                modalVideoId +
                '?autoplay=1" frameborder="0" sandbox="allow-scripts allow-same-origin ' + sandboxFlag + '" allowfullscreen></iframe>'
            );
            modalVideo.open();
          }
        });
      }
    }

    var tablistElem = document.querySelectorAll('.testimonials-habitat');
    for (var i = 0; i < tablistElem.length; i++) {
      bsSlider(tablistElem[i]);
    }
  };

  init();
})();
